import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import {
  loadNetwork,
  searchProfiles
} from "../../redux/actions/networkActions";
import { Link } from "react-router-dom";
import ListBox from "../events/components/ListBox";
import DropDownSelect from "../common/DropDownSelect";
import "./Network.scss";

export default function Network() {
  const userFromState = useSelector(state => state.user);
  const network = useSelector(state => state.network);
  const cities = useSelector(state => state.cities);
  const profiles = useSelector(state => state.profiles);
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [profileList, setProfileList] = useState([]);
  const [selectedCity, setSelectedCity] = useState(
    useSelector(state => state.selectedCity)
  );
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    console.log(userFromState);
    console.log(network);
    console.log(profiles);
    if ((network.length > 0 && network[0].id == 0) || !network.length > 0) {
      getNetwork();
    }
    if (!profiles.length > 0) {
      loadProfiles();
    } else {
      console.log(profiles);
    }
  }, [userFromState]);

  async function getNetwork() {
    const accessToken = await getAccessTokenSilently();
    await dispatch(loadNetwork(accessToken)).catch(error => {
      alert("Loading network failed" + error);
    });
  }

  async function loadProfiles() {
    const accessToken = await getAccessTokenSilently();
    await dispatch(searchProfiles(accessToken, "", "Hela Sverige"));
  }

  function handleCityChange(selected) {
    setSelectedCity(selected.value);
  }

  async function handleSearch(e) {
    e.preventDefault();
    const accessToken = await getAccessTokenSilently();
    const response = await dispatch(
      searchProfiles(accessToken, searchInput, selectedCity)
    );

    const responseList = response.filter(
      profile => profile.id != userFromState.id
    );

    const list = responseList.map(
      profile =>
        profile.id != userFromState.id && (
          <Link
            key={profile.id}
            className="profile-link"
            to={`/profile/${profile.id}`}
          >
            {profile.name}
          </Link>
        )
    );
    setProfileList(list);
  }

  /*
          <p>
          Här kan du se andra användare och lägga till dem i ditt nätverk. Andra
          kan inte se att du lagt till dem i ditt nätverk och du kan inte heller
          se vilka som lagt till dig i sitt nätverk. När du lagt till en
          användare i ditt nätverk kommer du kunna se vilka händelser som
          användaren har skapat eller anmält sig till. Den som väljer att göra
          sin profil osynlig kommer inte dyka upp här och kommer inte heller
          finnas kvar i någon annans nätverk.
        </p>
  */

  return (
    <div className="network-page">
      <ListBox
        className="network-list"
        label="Mitt nätverk"
        items={
          network.length > 0
            ? network.map(tracked => (
                <Link key={tracked.id} to={`/profile/${tracked.id}`}>
                  {tracked.name}
                </Link>
              ))
            : null
        }
        noItems={
          network.length == 0
            ? "Du har inte lagt till någon i ditt nätverk än."
            : null
        }
      />
      <div className="network-search">
        <form onSubmit={handleSearch}>
          <span className="label">Sök profil</span>
          <div className="inputname">
            <input
              type="text"
              name="name"
              placeholder="namn"
              value={searchInput}
              onChange={e => setSearchInput(e.target.value)}
            />
          </div>
          <DropDownSelect
            choices={cities}
            selected={selectedCity}
            onChange={handleCityChange}
            label="Sök i "
          />
          <button type="submit">Sök</button>
        </form>
      </div>
      <ListBox
        className="search-result"
        label="Sökresultat"
        items={profileList}
      />
    </div>
  );
}
